/**
 * @generated SignedSource<<33ad10be4c8ab154eb52841cf2cf21c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionDescription_softwareReleasesVersionDetail$data = {
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesVersionDetail_AsyncEditableVersionDescription" | "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection">;
  readonly " $fragmentType": "versionDescription_softwareReleasesVersionDetail";
};
export type versionDescription_softwareReleasesVersionDetail$key = {
  readonly " $data"?: versionDescription_softwareReleasesVersionDetail$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionDescription_softwareReleasesVersionDetail">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "versionDescription_softwareReleasesVersionDetail",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesVersionDetail_AsyncEditableVersionDescription"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "0db1312267a25b37317b854de67ee1d1";

export default node;
